import * as React from "react";

import {cs}             from "@Common/react/chain-services";
import {keyed}          from "@Common/react/keyed";

import {ConfirmCancel}     from "../common/confirm-cancel";
import {WizardControl}     from "../common/wizard-control";

import {Step1SelectList} from "./step-1-select-list/step-1-select-list";
import {Step2EditLists}  from "./step-2-edit-lists/step-2-edit-lists";

export const Crm = ({entityId, next, onClose, onCreated, onCancel, cancelLabel="Cancel"}) => cs(
    ["confirmCancel", (_, next) => ConfirmCancel({next})],
    ["step1", (_, next) => Step1SelectList({entityId, next})],
    ["step2", (_, next) => Step2EditLists({entityId, next})],
    ["wizardControl", ({confirmCancel, step1, step2}, next) => WizardControl({
        steps: [
            {
                render: ({resetNav}) => (
                    step1.render({
                        onNext: (params) => {
                            step2.prepare(params);
                            resetNav();
                        },
                        onCancel: async () => {
                            if (await confirmCancel()) {
                                onClose();
                                onCancel();
                            }
                            return false;
                        },
                        cancelLabel,
                    })
                ),
            },
            {
                condition: () => step2.ready,
                render: ({goBack}) => (
                    step2.render({
                        onBack: goBack,
                        onClose: async (mlIds = undefined) => {
                            mlIds && onCreated(mlIds);
                            onClose();
                        },
                    })
                ),
            },
        ],
        next,
    })],
    ({confirmCancel, wizardControl}) => (
        next({
            onPassiveClose: async () => {
                if (await confirmCancel()) {
                    onClose();
                    onCancel();
                }
                return false;
            },
            content: cs(
                keyed(wizardControl.currentStep.index),
                () => wizardControl.currentStep.render(),
            ),
        })
    )
);
